module.exports = __webpack_public_path__ + "media/images/logo-special-order-2484fd884ab78cf391e04239992bedfe.png";